import * as callActions from "./actions";

export default callActions;
